import React, { useState, useEffect } from "react";
import { insertTrainingData } from "../../services/Settings";
import { Alert } from "react-bootstrap";
import Loading from "../system/Loading";

export default function TaglessDataAdder(props) {
  const [processing, setProcessing] = useState(true);
  const [hidden, setHidden] = useState(false);
  const [error, setError] = useState(null);
  async function addData() {
    const values = {
      source: props.entry[0],
      date: props.entry[1].toString(),
      title: props.entry[3],
      text: props.entry[4],
    };
    try {
      await insertTrainingData(values);
      props.onComplete(props.index, true);
    } catch (err) {
      setError(err);
      console.log("Calling parent with index", props.index);
      props.onComplete(props.index, false);
    } finally {
      setProcessing(false);
      setTimeout(() => {
        setHidden(true);
      }, 750);
    }
  }

  useEffect(() => {
    addData();
  }, []);

  function output() {
    if (hidden) {
      return null;
    } else if (processing) {
      return (
        <Alert key={`alt_${props.index}`} variant={"info"}>
          <Loading isLoading={true} /> Adding entry no {props.index + 1}
        </Alert>
      );
    } else {
      return error ? (
        <Alert key={`alte_${props.index}`} variant={"danger"}>
          Unable to add entry no {props.index + 1} due to system error
        </Alert>
      ) : (
        <Alert key={`alts_${props.index}`} variant={"success"}>
          Successfully added entry no {props.index + 1}
        </Alert>
      );
    }
  }

  {
    return output();
  }
}
